export const getEnvVariable = (varName) => {
  const variable = process.env[varName];
  if (!variable) {
    throw new Error(`[getEnvVariable] Environment variable ${varName} is not set`);
  }
  return variable;
};